import { render, staticRenderFns } from "./EditActivity.vue?vue&type=template&id=3fae0042&"
import script from "./EditActivity.vue?vue&type=script&lang=js&"
export * from "./EditActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports